module.exports = __webpack_public_path__ + "img/gyant_dark_brown_ba_list.edd9192b.jpg";